module.exports = __webpack_public_path__ + "img/1F606.dea8afea.svg";